<template>
<div>
          <div >
    <DataTable :value="employeeList" :paginator="true"  exportFilename="employeeList" :rows="100" :filters="filters" ref="po" class="p-datatable-responsive p-datatable-gridlines" >
      <template #header>
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
            </div>
          </template>
      <Column header="S.N" field="">
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Name" :sortable="true" field="employeeName"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['employeeName']" />
        </template>
      </Column>
      <Column header="Address" :sortable="true" field="address"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['address']" />
        </template>
      </Column>
      <Column header="PanNo" :sortable="true" field="panNo"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['panNo']" />
        </template>
      </Column>
      <Column header="Contact" :sortable="true" field="contactNumber"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
        </template>
      </Column>
      <Column header="Salary Status" :sortable="true" field="salaryStatus"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['salaryStatus']" />
        </template>
      </Column>
      <Column header="Date Of Join" :sortable="true" field="dateOfJoin"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['dateOfJoin']" />
        </template>
      </Column>
      <!-- <Column header="Position" :sortable="true" field="employeePositionName"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['employeePositionName']" />
        </template>
      </Column> -->
      <!-- <Column header="Pay Head" :sortable="true" field="payHeadName"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['payHeadName']" />
        </template>
      </Column> -->
      <template #empty>No record found</template>
      <Column headerStyle="width:13em" header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editEmployee(slotProps.data)" />
          <Button class="p-button-raised p-button-success"
                  @click="viewEmployee(slotProps.data)" icon="pi pi-eye"/>
                  <Button class="p-button-raised "
                  @click="viewImage(slotProps.data)" icon="pi pi-eye"/>
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
        </template>
      </Column>
    </DataTable>
          </div>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deleteEmployee"/>
    <Dialog header="View Document " :modal="true"
                :visible.sync="openImageViewer" :style="{width: '50vw'}">
          <!-- <div v-if="this.imageList.length > 0"> -->
              <label for="a">Personal</label>
            <div class="card">
              <!-- <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                <template #item="slotProps"> -->
                  <div class="product-item">
                    <div class="product-item-content">
                      <div class="p-mb-3">
                        <img :src="personImage" style="height:100px;width:100px" class="product-image"/>
                      </div>
                      <div>
                        <!-- <div class="car-buttons p-mt-5">
                          <Button class="p-button-raised p-button-danger"
                                  @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                        </div> -->
                      </div>
                    </div>
                  </div>
                <!-- </template>
              </Carousel> -->
            </div>
              <label for="a">Citizenship Front</label>
            <div class="card">
              <!-- <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                <template #item="slotProps"> -->
                  <div class="product-item">
                    <div class="product-item-content">
                      <div class="p-mb-3">
                        <img :src="citizenshipFront" style="height:100px;width:100px" class="product-image"/>
                      </div>
                      <div>
                        <!-- <div class="car-buttons p-mt-5">
                          <Button class="p-button-raised p-button-danger"
                                  @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                        </div> -->
                      </div>
                    </div>
                  </div>
                <!-- </template>
              </Carousel> -->
            </div>
              <label for="a">Citizenship Back</label>
            <div class="card">
              <!-- <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                <template #item="slotProps"> -->
                  <div class="product-item">
                    <div class="product-item-content">
                      <div class="p-mb-3">
                        <img :src="citizenshipBack" style="height:100px;width:100px" class="product-image"/>
                      </div>
                      <div>
                        <!-- <div class="car-buttons p-mt-5">
                          <Button class="p-button-raised p-button-danger"
                                  @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                        </div> -->
                      </div>
                    </div>
                  </div>
                <!-- </template>
              </Carousel> -->
            </div>
              <label for="a">CV</label>
            <div class="card">
              <!-- <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                <template #item="slotProps"> -->
                  <div class="product-item">
                    <div class="product-item-content">
                      <div class="p-mb-3">
                         <a style="font-size: 18px" download="CV.pdf"
             :href="fileName">Click here to Download</a>
                      </div>
                      <div>
                        <!-- <div class="car-buttons p-mt-5">
                          <Button class="p-button-raised p-button-danger"
                                  @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                        </div> -->
                      </div>
                    </div>
                  </div>
                <!-- </template>
              </Carousel> -->
            </div>

          <!-- </div> -->
          <template #footer>
            <Button class="p-button-raised p-button-danger" @click.prevent="back" label="Back"/>
          </template>
        </Dialog>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
export default {
  name: 'employeeList',
  data() {
    return {
      editing: false,
      employeeId: null,
      deleteDialog: false,
      openImageViewer: false,
      citizenshipFront: '',
      citizenshipBack: '',
      personImage: '',
      fileName: '',
      filters: {}
    }
  },
  computed: {
    employeeList() {
      return this.$store.state.hr.employeeList
    }
  },
  mounted() {
    this.findEmployeeList()
  },
  methods: {
    async findEmployeeList() {
      await this.$store.dispatch('loadEmployeeList')
    },
    editEmployee(data) {
      this.$emit('edit-employee', data)
    },
    viewEmployee(data) {
      this.$emit('view-employee', data)
    },
    async deleteEmployee(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let employee = {
        id: this.employeeId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deleteEmployee', employee)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Employee ' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    viewImage(data) {
      this.citizenshipFront = data.citizenshipFront
      this.citizenshipBack = data.citizenshipBack
      this.personImage = data.personImage
      this.fileName = data.fileName
      this.openImageViewer = true
    },
    exportCSV() {
      this.$refs.po.exportCSV()
    },
    back() {
      this.openImageViewer = false
    },
    openDeleteDialog(id) {
      this.employeeId = id
      this.deleteDialog = true
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog,
    Dialog
  }
}
</script>



// WEBPACK FOOTER //
// employeeList.vue?222c2470